var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col justify-center h-screen",attrs:{"id":"app"}},[_c('Timer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }